import store from '@stores';
import { isOnline } from '@helpers';

export default async function minimalAuth({ next }) {
  if (isOnline() && !Object.keys(store.state.auth.user).length) {
    try {
      await store.dispatch('auth/fetchUser');
    } catch (e) {
      console.log('Unable to fetch user');
    }
  }

  return next();
}
